/* 
Site global JS, as a rule of thumb, 
this should only contain JS that is 
needed for the majority of pages on the site.
*/
import "./resource_v1";

(function ($) {
  $(document).ready(function () {
    // here we go
    if (!Cookies.get("hideTopBar")) $(".announcement-wrap").removeClass("hide");

    $("a#closeit").click(function () {
      Cookies.set("hideTopBar", "true", { expires: 1 });
      $(".announcement-wrap").addClass("hide");
      return false;
    });


    $(".external-link a").click(function () {
      alert("You are now leaving the Habitat Kent local site.");
    });
    $( 'body' ).on('click', '.external-link > a', function(){ 
      alert("You are now leaving the Habitat Kent local site."); 
      } );
  });
})(jQuery);

import "./nav";
